<style lang="less">
.mobox {
  @picture: 'data:image/png;base64,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';

  @effect: 0.36s;
  @colour: #e7e8e9;
  @deep: #0081a3;
  @theme: #00a6c9;
  @anchor: #bdbdbd;
  @tiper: #787878;

  & {
    position: relative;
    overflow: auto;
    scroll-behavior: smooth;
    padding: 60px 0;
    height: calc(100vh - 60px);
  }
  // &--topnav {
  //   background-position: center top;
  //   background-color: white;
  //   background-image: ~'url(@{picture})'; //url(@picture);
  //   background-repeat: no-repeat;
  //   background-size: contain;
  //
  //   position: absolute;
  //   top: 0;
  //   left: 0;
  //   right: 0;
  // }
  &--analog {
    & {
      //padding-top: 17.06% !important;
      position: relative;
    }
  }

  &--setting {
    & {
      background: #fff;
      font-size: 20px;

      border-radius: 20px;
      width: 40px;
      height: 80px;

      position: fixed;
      bottom: 120px;
      z-index: 3;
      right: calc(50% - 268.5px);
      cursor: pointer;
    }

    .icon {
      & {
        font-size: 20px;
        width: 40px;
        line-height: 40px;
        transition: 0.6s;
        text-align: center;
        color: #b0afb2;
      }
      &:hover {
        opacity: 0.5;
      }
    }
    // .up-page {
    //   text-align: center;
    //   background: #fff;
    //   line-height: 40px;
    //   border-radius: 20px;
    //   width: 40px;
    //   height: 40px;
    //   font-size: 20px;
    //   position: fixed;
    //   bottom: 120px;
    //   z-index: 3;
    //   right: calc(50% - 268.5px);
    //   color: #b0afb2;
    //   cursor: pointer;
    //   transition: 0.6s;
    //   &:hover {
    //     opacity: 0.5;
    //   }
    //   .icon {
    //     font-size: 20px;
    //     text-align: center;
    //     color: #b0afb2;
    //   }
    // }
  }

  &--tiper {
    right: 50%;
    position: absolute;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: center;

    span {
      height: 30px;
      padding: 3px 9px;
      border-radius: 3px;
      color: @tiper;
      background-color: @colour;
    }

    bdo {
      width: 30px;
      height: 1px;
      border-top: 1px dashed @tiper;
    }
  }

  &--container {
    // Reset Height for mobox
    height: auto !important;
  }

  &--groove {
    position: relative;
    border-radius: 2px;
    border: 1px dashed @colour;

    &--anchor {
      transition: opacity @effect, background-color @effect;

      padding: 0 2px;

      z-index: 99;
      top: 1px;
      bottom: 1px;
      right: 1px;

      position: absolute;

      opacity: 0;

      display: flex;
      align-items: center;

      background-color: @anchor;

      cursor: move;

      // &:hover + .groove .groove--item {
      //   border-color: @theme;
      //   background: @colour;
      // }

      i {
        font-size: 3px;
      }

      &:hover {
        background-color: @theme;
      }
    }

    &--mask {
      // height: 1px;
      // min-height: 20px;
    }

    &.active /* &:hover */ {
      border-color: @deep;
      // background: @colour;

      .mobox--groove--anchor {
        opacity: 1;
      }
    }

    &.hover {
      border-color: @theme;
      // background: @colour;
    }

    &.sortable-chosen {
      border-color: @theme !important;

      .mobox--groove--anchor {
        background-color: @deep;
      }
    }
  }

  &--hover:hover {
    // border-color: @colour;
    // background: #fff;
  }

  .hardness {
    margin-left: auto;
    margin-right: auto;
  }
}
</style>

<template>
  <div class="mobox" :id="id" v-if="preview || visual.materials.length">
    <!-- 设置和侧边向上功能   -->
    <div class="mobox--setting" v-if="!preview">
      <visual-funIcon v-for="(item, key) in icon" :key="key" :icon="item" class="icon" event="eve" @click="handleIcon(item)"/>
    </div>

    <!-- Tiper of Mobox -->
    <div v-if="!preview" class="mobox--tiper" :style="{ top: `${preset.mobile[setting.mode].height + 60 - 16}px`, marginRight: `${preset.mobile[setting.mode].width / 2}px` }">
      <span>{{ setting.mode }}</span>
      <bdo />
    </div>

    <visual-page class="hardness mobox--analog" :hardness="preset.mobile[setting.mode]" v-for="(source, key) in store" :key="source?.id" :index="key" v-if="visual.effect">
      <template #default="{ size }">
        <!-- Editor - Some Proof -->
        <visual-proof :css="{ minHeight: `${setting.flow.line}px`, backgroundColor: setting.backgroundCss.color }" :source="source?.context" :index="key" />
      </template>
    </visual-page>
  </div>
</template>

<script>
export default {
  props: {
    store: {
      type: [Object],
      default() {
        return [];
      },
    },
    id: {
      type: [String],
      default() {
        return '';
      },
    },
  },

  data() {
    return {
      drag: false,
      icon: ['SettingOutlined', 'UpOutlined'],
    };
  },

  methods: {
    eve(item) {
      debugger
      this.$store.update('visual', { active: null });
    },
    handleIcon(item) {
      switch (item) {
        case "SettingOutlined":
          this.$store.update('visual', { active: null });
          break;
        case "UpOutlined":
          document.querySelector('.mobox').scrollTop = 0;
          break;
        default:
          return ;
      }
    },
    getKey(item) {
      return item.order || 0;
    },
  },
};
</script>
